
import { baseUrl } from "../../constants";

export default {
    "formTitle": "Add Cargo UoM",
    "tableTitle": "Cargo UoM List",
    "apiDetails": {
        startUp: () => {
        },
        list: {
            url: `${baseUrl}/api/system/cargo/list`,
            payload: {
                "search": "",
                "offset": 0,
                "limit": 50,
                "sort": "DESC"
            }
        },
        add: `${baseUrl}/api/system/cargo`,
        edit: `${baseUrl}/api/system/cargo/edit`,
        delete: `${baseUrl}/api/system/cargo/remove`
    },
    "tableCol": [
        {
            name: 'Unit Name',
            selector: row => row.unitName,
            sortable: true
        },
        {
            name: 'Description',
            selector: row => row.description,
            sortable: true
        }
    ],
    "formData": [
        {
            "formType": "flex",
            "formFields": [
                {
                    type: 'text',
                    label: 'Unit Name',
                    name: 'unitName',
                    required: true
                }
            ]
        },
        {
            formType: 'flex',
            formFields: [
                {
                    type: 'textArea',
                    label: 'Description',
                    name: 'description'
                }
            ]
        }
    ],
    "mockData": [{
        "unitName": "sfs",
        "description": "dgdg"
    }]
}